module.exports = __webpack_public_path__ + "static/main-picture-6c5ed86f837ec8c08adc14fdca316f34.png";